import { render, staticRenderFns } from "./DrugCreate.vue?vue&type=template&id=78423c89"
import script from "./DrugCreate.vue?vue&type=script&lang=js"
export * from "./DrugCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports